import { Component, OnInit } from '@angular/core';
declare var $:any;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    this.stickyQuery();
    $(document).ready(function(){
      $('.dropdown-submenu a.test').on("click", function(e){
        $(this).next('ul').toggle();
        e.stopPropagation();
        e.preventDefault();
      });
    });
    $(document).ready(function(){
      $('.dropdown-submenu a.test').on("mouseover", function(e){
        $(this).next('ul').toggle();
        e.stopPropagation();
        e.preventDefault();
      });
    });
  }
  stickyQuery(){
    $(document).ready(function() {
  
      $(window).scroll(function () {
          //if you hard code, then use console
          //.log to determine when you want the 
          //nav bar to stick.  
      
        if ($(window).scrollTop() > 122) {
          $('#menu-header').addClass('sticky');
        }
        if ($(window).scrollTop() < 123) {
          $('#menu-header').removeClass('sticky');
        }
      });
    });
    
  }
  erpLogin(link:string){
    window.open(link);
  }
  toggleMenu(){
    if($('#menuNav').hasClass('showing')){
      $('#menuNav').removeClass('showing');
      $('#menuNav').hide();
      console.log(1); 
    }else{
      $('#menuNav').addClass('showing')
      $('#menuNav').show();
    }
   
  }
}
